/**
 * @desc 批量解绑sku
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/batchUnBindSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
